import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=490d8204&scoped=true"
import script from "./detection.vue?vue&type=script&lang=js"
export * from "./detection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d8204",
  null
  
)

export default component.exports